import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { SIMPLE_FOOD_MOOD_FRAGMENT } from '../fragments'

const SAVE_FOOD_MOODS_MUTATION = gql`
  mutation saveFoodMoods($data: [SimpleFoodMoodInput!]!) {
    saveFoodMoods(data: $data) {
      results {
        ...SimpleFoodMoodFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${SIMPLE_FOOD_MOOD_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default SAVE_FOOD_MOODS_MUTATION
